import { useSelector } from 'react-redux'
import {
  useCommunity,
  useCommunityText,
  useDocumentTitle,
  isTeachingArtistEnabled,
} from 'utils'
import { selectors as partnerSelectors } from './partners/reducer'
import { selectors as schoolSelectors } from './schools/reducer'
import { selectors as artistSelectors } from './teaching-artist/reducer'

function joinTitleParts(parts) {
  return parts.filter(Boolean).join(' | ')
}

function useMapDocumentTitle() {
  const pathname = useSelector((state) => {
    const loc = state.routing && state.routing.locationBeforeTransitions
    return (loc && loc.pathname) || ''
  })
  const partner = useSelector(partnerSelectors.partner)
  const school = useSelector(schoolSelectors.school)
  const artist = useSelector(artistSelectors.artist)
  const community = useCommunity()
  const t = useCommunityText()

  const baseTitle = t('map.title') || 'artlook Map'
  const communityName = community && community.name

  const partnerLabel = t('map.documentTitle.partner') || 'Partner'
  const schoolLabel = t('map.documentTitle.school') || 'School'
  const artistLabel = t('map.documentTitle.teachingArtist') || 'Teaching Artist'
  const searchLabel = t('map.documentTitle.search') || 'Search'

  const suffix = communityName || baseTitle
  let title

  if (pathname === '/search') {
    title = joinTitleParts([searchLabel, suffix])
  } else if (/^\/partners\/[^/]+/.test(pathname)) {
    const name = partner && partner.name
    title = name
      ? joinTitleParts([name, partnerLabel, suffix])
      : joinTitleParts([partnerLabel, suffix])
  } else if (/^\/schools\/[^/]+/.test(pathname)) {
    const name = school && school.name
    title = name
      ? joinTitleParts([name, schoolLabel, suffix])
      : joinTitleParts([schoolLabel, suffix])
  } else if (
    isTeachingArtistEnabled(community) &&
    /^\/teaching-artist\/[^/]+/.test(pathname)
  ) {
    const name = artist && artist.name
    title = name
      ? joinTitleParts([name, artistLabel, suffix])
      : joinTitleParts([artistLabel, suffix])
  } else {
    title = baseTitle
  }

  useDocumentTitle(title)
}

export default useMapDocumentTitle
